'use client';

import { useState } from "react";
import Container from "@/components/Container";
import Button from "@/components/Button";
import { apiPost } from "@/lib/api";
import Logo from "@/components/Logo";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit() {
    setErr(null);
    setLoading(true);
    try {
      await apiPost("/auth/forgot-password", { email });
      setDone(true);
    } catch {
      setErr("Unable to send reset link. Try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container className="grid gap-10 lg:grid-cols-[1fr_1.2fr] lg:items-center">
      <div className="space-y-6">
        <Logo />
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-800">Password reset</p>
          <h1 className="mt-3 text-4xl font-serif text-[#1a1c18]">Reset your password.</h1>
          <p className="mt-3 text-base text-[#3c4038]">
            Enter the email used for your booking or account. We’ll send a reset link.
          </p>
        </div>
      </div>

      <div className="rounded-[28px] bg-white/90 p-8 shadow-[0_40px_90px_-60px_rgba(21,34,26,0.95)] ring-1 ring-black/5 backdrop-blur">
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold text-[#1a1c18]">Forgot password</h2>
          <p className="text-sm text-[#5b5f57]">We’ll email you a secure reset link.</p>
        </div>
        <div className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-[#2f322c]">Email</label>
            <input
              className="mt-2 w-full rounded-xl border border-black/10 bg-white px-4 py-3 text-sm text-[#1a1c18] shadow-sm outline-none transition focus:border-emerald-600 focus:ring-2 focus:ring-emerald-200"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
            />
          </div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          {done && <p className="text-sm text-emerald-700">If the email exists, a reset link has been sent.</p>}
          <Button onClick={onSubmit} disabled={loading || !email} className="w-full">
            {loading ? "Sending..." : "Send reset link"}
          </Button>
        </div>
        <div className="mt-6 text-sm">
          <a className="text-emerald-700 hover:underline" href="/portal/login">{"<- Back to login"}</a>
        </div>
      </div>
    </Container>
  );
}
